import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { selectWorks } from '../../../Api/selectors';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { completeVehicleTransport, deleteVehicleProperty } from '../../../Vehicles/actions';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { refreshBoards } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

import styles from './Transport_1_plan_extern.module.css';
import cn from 'classnames';
import { TransportAssignableOptions, TransportAssignableSortMap } from './Transport_1_nl_in';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';
import { selectAddress } from '../../../Address/selectors';

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }

  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  loading: false,
  confirmReset: false,
};

/* eslint-disable react/prefer-stateless-function */
class Transport_1_plan_externComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <ModalComponent
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_1_plan_extern.modal.title')}
      >
        {this.renderBody()}
      </ModalComponent>
    );
  }

  renderBody() {
    if (this.props.work || this.state.loading)
      return (
        <HBox center>
          <Loader small />
        </HBox>
      );
    return (
      <>
        <HBox center vCenter>
          {this.state.confirmReset ? (
            <VBox center>
              <div>{this.lbl('reset')}?</div>
              <HBox>
                <ButtonComponent
                  style={'ButtonSoftEdit'}
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.resetTransport(() => {
                      this.reset();
                    });
                  }}
                >
                  {this.lbl('confirm')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.setStateFn({ confirmReset: false })}>
                  {this.lbl('cancel')}
                </ButtonComponent>
              </HBox>
            </VBox>
          ) : (
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ confirmReset: true })}>
              <EditSquare />
              {this.lbl('reset')}
            </ButtonComponent>
          )}
        </HBox>
        <div className="d-flex gap-2 mt-4">
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.props.done(this.reset.bind(this))}>
                {this.lbl('complete')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
            </>
          )}
        </div>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    return (
      <Cell className={styles.cell}>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <div className={cn('regplate', styles.regplate)}>
              <span style={{ opacity: 0.4 }}>({vehicle.id})</span>
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
            </div>
            <HBox vCenter right>
              <VehicleStatusLabel color={'#727cf5'}>in</VehicleStatusLabel>
              &nbsp;
              <VehicleStatusLabel>
                {vehicle?.transporter_extern ? vehicle?.transporter_extern : 'Niet toegewezen'}
              </VehicleStatusLabel>
            </HBox>
          </HBox>
          <div className="address">
            {this.props.fromCompanyName && (
              <CompanyLabelById
                fetchName
                transportCard
                transport_to={vehicle?.transport_incoming_from_company_name}
                company_id={vehicle?.transport_incoming_from_company_id}
              />
            )}
            {(this.props.fromCompanyName || this.props.loadSingleRes) && (
              <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
            )}
            <div className="mb-1">
              <CompanyLabelById fetchPhone company_id={vehicle.transport_incoming_from_company_id} />
            </div>
          </div>
          <div className="address">
            {(this.props.fromCompanyName || this.props.loadSingleRes) && (
              <CompanyLabelById
                fetchName
                transportCard
                transport_to={vehicle?.transport_incoming_to_company_name}
                company_id={vehicle.buying_company}
              />
            )}
            {(this.props.address || this.props.loadSingleRes) && (
              <AddressFields inlineshort addressId={vehicle.transport_to_address_id} />
            )}
          </div>
          <hr />
          {vehicle.brand_name} {vehicle.model_name}
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

Transport_1_plan_externComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    fromCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_incoming_from_company_id, 'name'),
    buyingCompanyName: selectCompanyProperty(ownProps.cell.vehicle.buying_company, 'name'),
    fromAddress: selectAddress(ownProps.cell.vehicle.transport_from_address_id),
    toAddress: selectAddress(ownProps.cell.vehicle.transport_to_address_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    resetTransport(callback) {
      let id = ownProps.cell.vehicle.id;
      dispatch(
        deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_assigned_to', () => {
          dispatch(
            deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_initiated', () => {
              dispatch(refreshBoards());
              callback();
            }),
          );
        }),
      );
    },
    done(addressId, callback) {
      dispatch(
        completeVehicleTransport(ownProps.cell.vehicle.id, false, ownProps.action.functionName, () => {
          console.log(ownProps.action.functionName, '*** FUNCTION NAME ***');
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_1_plan_extern = compose(withConnect, withRouter)(Transport_1_plan_externComp);
